import { handleApiError } from 'utils/api';
import { env } from '../../../../constants';
import { HARD_SKILLS_API_URL } from './constants';
import { HardSkillsResponse } from './types';

const DEFAULT_PAGE_SIZE = 100;
const acceptedLanguages = ['DE', 'EN'];

export const fetchHardSkillsPage = async (
  page: number,
  language: (typeof acceptedLanguages)[number]
): Promise<HardSkillsResponse | undefined> => {
  const response = await fetch(
    `${env.VITE_API_BASE_URL}/${HARD_SKILLS_API_URL}?page=${page}&size=${DEFAULT_PAGE_SIZE}`,
    {
      method: 'GET',
      headers: {
        'Accept-Language': language
      }
    }
  );

  if (!response.ok) {
    await handleApiError(response);
  }

  return response.json() as Promise<HardSkillsResponse | undefined>;
};
